import { render } from "./Section.vue?vue&type=template&id=09d2e7aa&scoped=true"
const script = {}

import "./Section.vue?vue&type=style&index=0&id=09d2e7aa&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d2e7aa"]])

export default __exports__